import {
  CAlert,
  CButton,
  CButtonGroup,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem, updateItem, ItemRequestStatus } from "../../api/generics";
import Errors, { getFieldErrors } from "../../models/errors";
import { SUCCESS } from "../../utils/constants/tags";
import { FieldErrors } from "../form/FieldErrors";
import { errorAlert } from "../utils/messages";
import { emptyValueOnUndefined } from "../../utils/fields";
import { RootState } from "../../store";
import { useSelector } from "react-redux";

import AccountingReportLogEntry, {
  newAccountingReportEntry,
} from "../../models/accounting-reports";

interface AccountingReportLogFormProps {
  initialAccountingReportLog?: AccountingReportLogEntry;
  initialErrors?: Errors;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AccountingReportLogForm: React.FC<AccountingReportLogFormProps> = ({
  initialAccountingReportLog,
  initialErrors,
  onCancel,
  onSuccess,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);
  const [editingAccountingReportLog, setEditingAccountingReportLog] =
    useState<AccountingReportLogEntry>(
      initialAccountingReportLog
        ? initialAccountingReportLog
        : newAccountingReportEntry()
    );

  const [errors, setErrors] = useState<Errors>(
    initialErrors ? initialErrors : {}
  );
  const [submitting, setSubmitting] = useState(false);

  const onObsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingAccountingReportLog({
      ...editingAccountingReportLog,
      obs: e.target.value,
    });
  };

  const onSave = async () => {
    setSubmitting(true);
    let toSendAccountingReportLog = {
      ...editingAccountingReportLog,
      companyId: company.id,
    };

    let requestPromise: Promise<ItemRequestStatus<AccountingReportLogEntry>>;
    if (editingAccountingReportLog.id === undefined) {
      //this will never enter here
      requestPromise = createItem<AccountingReportLogEntry>(
        "/accounting_reports/create/",
        toSendAccountingReportLog
      );
    } else {
      requestPromise = updateItem<AccountingReportLogEntry>(
        `/accounting_reports/${toSendAccountingReportLog.id}/`,
        toSendAccountingReportLog
      );
    }

    const accountingReportLogStatus = await requestPromise;

    if (accountingReportLogStatus.status !== SUCCESS) {
      if (accountingReportLogStatus.errors !== undefined) {
        setErrors(accountingReportLogStatus.errors);
      }

      let message = "Ha ocurrido un error!!";
      if (accountingReportLogStatus.detail !== undefined) {
        message = accountingReportLogStatus.detail;
      }
      errorAlert(message);
    } else {
      setErrors({});
      clearForm();
      onSuccess();
    }
    setSubmitting(false);
  };

  const onClose = () => {
    clearForm();
    onCancel();
  };

  const clearForm = () => {
    setErrors({});
  };

  useEffect(() => {
    setEditingAccountingReportLog(
      initialAccountingReportLog
        ? initialAccountingReportLog
        : newAccountingReportEntry()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialAccountingReportLog]);

  useEffect(() => {
    setErrors(initialErrors ? initialErrors : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialErrors]);

  return (
    <>
      <fieldset disabled={submitting}>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Observación:</CLabel>
            </CCol>
            <CCol>
              <CInput
                type="text"
                value={emptyValueOnUndefined(editingAccountingReportLog.obs)}
                onChange={onObsChange}
                placeholder="Observación"
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("obs", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="float-right">
          <CButtonGroup>
            <CButton type="button" color="secondary" onClick={onClose}>
              Atrás
            </CButton>
            <CButton type="submit" color="primary" onClick={onSave}>
              {submitting ? (
                <Spinner
                  animation="grow"
                  style={{
                    height: "17px",
                    width: "17px",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <></>
              )}
              {submitting ? "Guardando..." : "Guardar"}
            </CButton>
          </CButtonGroup>
        </CFormGroup>
      </fieldset>
    </>
  );
};

export default AccountingReportLogForm;
